<!-- <template>
  <v-fade-transition mode="out-in">
    <router-view v-if="render" />
    <loading-screen v-else />
  </v-fade-transition>
</template>

<script>
import axios from 'axios';
export default {
  name: "App",
  components: {
    "loading-screen": () => import("./views/LoadingView.vue"),
  },
  created() {

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = urlParams.get("token"); 
    if (token) {
          localStorage.setItem("token", token);
          location.replace("/");
          this.$router.push('/dashboard');
        }

  },
  data: () => ({
    render: false,
    data: null,
  }),
  methods: {
    getUser() {
      if (localStorage.getItem("token")) {
        // if(this.$store.state.user){
          this.render = false;

          axios
          .get(process.env.VUE_APP_BASE_URL + "/user/find_user/" + this.$store.state.user.id)
          .then((res) => {
            if (res.status == 200) {

              if (res.data.data.token) {
                localStorage.setItem("token", res.data.token);
                this.data = res.data;
                if(this.data.roleID){
                this.$store.dispatch("setUser", res.data.data);
                // this.$store.dispatch("setModule", res.data.data.module)
                if(this.$route.path == "/"){
                  this.$router.push("/" + this.data.BaseUrl + "/dashboard");
                  setTimeout(() => {
                    this.$router.go(0)
                  }, 0);
                }
                }
              }
              else{
                localStorage.clear();
                this.$router.push('/');
              }
              setTimeout(() => {
              this.render = true;
              }, 1000);


            }
          });

          this.axiosCall("/find_user", "GET")
          .then((res) => {
            if (res.data.data.token) {
              localStorage.setItem("token", res.data.token);
              this.data = res.data;
              if(this.data.roleID){
              this.$store.dispatch("setUser", res.data.data);
              // this.$store.dispatch("setModule", res.data.data.module)
              if(this.$route.path == "/"){
                this.$router.push("/" + this.data.BaseUrl + "/dashboard");
                setTimeout(() => {
                  this.$router.go(0)
                }, 0);
              }
              }
            }
            else{
              localStorage.clear();
              this.$router.push('/');
            }
            setTimeout(() => {
            this.render = true;
            }, 1000);

          })
          .catch((error) => {
            console.log(error);
            localStorage.clear();
            this.$router.push('/');
            setTimeout(() => {
            this.render = true;
            }, 1000);
          });
        // }
      } else {
        this.render = true;
        localStorage.clear();
        this.$router.replace("/", () => {});
      }
    },
  },
};
</script> -->
<template>
  <div>
    <router-view v-if="render"/>
    <ConnectionStatus />

    <!-- SOCKET NOTIFICATIONS -->
    <div
      class="pointer-events-none fixed bottom-5 right-5 z-[99999] flex w-[calc(100%-2rem)] max-w-sm flex-col items-end gap-2 sm:w-full"
      aria-live="polite"
      aria-atomic="false"
    >
      <transition name="socket-notification-fade">
        <div
          v-if="socketNotificationQueue.length > 0"
          class="rounded-full border border-green-600 bg-green-600 px-3.5 py-2 text-xs font-bold text-white shadow-lg"
        >
          +{{ socketNotificationQueue.length }}
          {{ socketNotificationQueue.length === 1 ? "notification" : "notifications" }}
        </div>
      </transition>

      <transition-group
        name="socket-notification-stack"
        tag="div"
        class="flex w-full flex-col gap-2"
      >
        <div
          v-for="notification in visibleSocketNotifications"
          :key="notification.id"
          class="pointer-events-auto relative overflow-hidden rounded-xl border border-emerald-300 bg-white shadow-xl ring-1 ring-black/5"
        >
          <div class="absolute inset-y-0 left-0 w-1 bg-emerald-500"></div>

          <div class="flex items-start gap-3 py-4 pl-5 pr-4">
            <div class="mt-0.5 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-700 ring-1 ring-emerald-200">
              <svg
                viewBox="0 0 24 24"
                class="h-4 w-4"
                fill="none"
                stroke="currentColor"
                stroke-width="2.2"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path d="M20 6 9 17l-5-5"></path>
              </svg>
            </div>

            <div class="min-w-0 flex-1 pr-5">
              <p class="text-sm font-bold text-gray-900">
                {{ notification.title }}
              </p>

              <p
                v-if="notification.message"
                class="mt-1 break-words text-xs leading-5 text-gray-600"
              >
                {{ notification.message }}
              </p>

              <button
                v-if="notification.route"
                type="button"
                class="mt-3 inline-flex items-center rounded-md bg-green-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm transition hover:bg-green-700 active:scale-[0.98]"
                @click="openSocketNotificationRoute(notification)"
              >
                View details
              </button>
            </div>

            <button
              type="button"
              class="absolute right-2.5 top-2.5 inline-flex h-7 w-7 items-center justify-center rounded-md text-gray-400 transition hover:bg-gray-100 hover:text-gray-600"
              title="Close notification"
              @click="dismissSocketNotification(notification.id)"
            >
              <svg
                viewBox="0 0 24 24"
                class="h-3.5 w-3.5"
                fill="none"
                stroke="currentColor"
                stroke-width="2.2"
                stroke-linecap="round"
                aria-hidden="true"
              >
                <path d="M6 6l12 12M18 6 6 18"></path>
              </svg>
            </button>
          </div>

          <div class="h-1 w-full bg-gray-100">
            <div
              class="socket-notification-progress h-full bg-emerald-500"
              :style="{ animationDuration: `${notification.duration}ms` }"
            ></div>
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import { socket, connect } from "@/socket";
import pingSound from "@/assets/audio/ping_sound.mp3";
import axios from "@/services/api";
import ConnectionStatus from "./views/ConnectionStatus.vue";

export default {
  data() {
    return {
      userId: null,
      audio: null,
      audioUnlocked: false,
      render: false,

      activeSocketNotifications: [],
      socketNotificationQueue: [],
      socketNotificationCounter: 0,
      socketNotificationTimers: {},
      maxVisibleSocketNotifications: 2,
      socketNotificationDuration: 15000,
    };
  },
  components: {
    ConnectionStatus
  },
  computed: {
    visibleSocketNotifications() {
      return [...this.activeSocketNotifications].reverse();
    },
  },
  mounted() {
     this.$router.isReady().then(() => {
      this.getUser();
    });
    // Create reusable audio instance
    this.audio = new Audio(pingSound);

    // Unlock audio after first user interaction (browser policy)
    window.addEventListener(
      "click",
      () => {
        this.audioUnlocked = true;
      },
      { once: true }
    );

    // Get user from store
    const storedUserId = this.$store?.state?.user?.id;

    if (storedUserId) {
      this.userId = storedUserId;

      // Connect socket
      connect(this.userId);

      // Prevent duplicate listeners
      socket.off("ping");
      socket.off("connect");
      socket.off("disconnect");

      // Global listener for pings
      socket.on("ping", (data) => {
        this.showSocketNotification(data);
        this.playPingSound();
      });

      // Handle reconnect automatically
      socket.on("connect", () => {
        console.log("Socket connected:", socket.id);

        if (this.userId) {
          socket.emit("join", this.userId);
          console.log("Re-joined room for user:", this.userId);
        }
      });

      // Optional: handle disconnect
      socket.on("disconnect", (reason) => {
        console.warn("Socket disconnected:", reason);
      });
    }
  },
  created() {
  const urlParams = new URLSearchParams(window.location.search);

    const urlToken = urlParams.get("token");
    const urlUserId = urlParams.get("user_id");

    const localToken = localStorage.getItem("token");

    if (urlToken) {
      if (!localToken || urlToken === localToken) {
        localStorage.setItem("token", urlToken);

        if (urlUserId) {
          localStorage.setItem("user_id", urlUserId);
        }

        // remove query from URL
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
      } else {
        localStorage.clear();
        this.$router.replace("/");
        return;
      }
    }
  },
  beforeUnmount() {
    this.clearSocketNotificationTimers();
  },
  methods: {
    showSocketNotification(data) {
      const notification = {
        id: ++this.socketNotificationCounter,
        title: String(data?.title || "").trim() || "New Notification",
        message: String(data?.message || "").trim(),
        route: data?.route || null,
        duration: this.socketNotificationDuration,
      };

      if (
        this.activeSocketNotifications.length <
        this.maxVisibleSocketNotifications
      ) {
        this.activateSocketNotification(notification);
      } else {
        this.socketNotificationQueue.push(notification);
      }
    },

    activateSocketNotification(notification) {
      this.activeSocketNotifications.push(notification);

      this.socketNotificationTimers[notification.id] =
        window.setTimeout(() => {
          this.dismissSocketNotification(notification.id);
        }, notification.duration);
    },

    dismissSocketNotification(id) {
      const timer = this.socketNotificationTimers[id];

      if (timer) {
        window.clearTimeout(timer);
        delete this.socketNotificationTimers[id];
      }

      const activeIndex =
        this.activeSocketNotifications.findIndex(
          (notification) =>
            Number(notification.id) === Number(id)
        );

      if (activeIndex !== -1) {
        this.activeSocketNotifications.splice(activeIndex, 1);

        this.$nextTick(() => {
          this.showNextQueuedSocketNotification();
        });

        return;
      }

      const queueIndex =
        this.socketNotificationQueue.findIndex(
          (notification) =>
            Number(notification.id) === Number(id)
        );

      if (queueIndex !== -1) {
        this.socketNotificationQueue.splice(queueIndex, 1);
      }
    },

    showNextQueuedSocketNotification() {
      if (
        this.activeSocketNotifications.length >=
          this.maxVisibleSocketNotifications ||
        this.socketNotificationQueue.length === 0
      ) {
        return;
      }

      const nextNotification =
        this.socketNotificationQueue.shift();

      if (nextNotification) {
        this.activateSocketNotification(nextNotification);
      }

      if (
        this.activeSocketNotifications.length <
          this.maxVisibleSocketNotifications &&
        this.socketNotificationQueue.length > 0
      ) {
        this.showNextQueuedSocketNotification();
      }
    },

    clearSocketNotificationTimers() {
      Object.values(
        this.socketNotificationTimers
      ).forEach((timer) => {
        window.clearTimeout(timer);
      });

      this.socketNotificationTimers = {};
    },

    openSocketNotificationRoute(notification) {
      const route = notification?.route;

      if (!route) return;

      if (typeof route === "string") {
        const routePath = route.startsWith("/")
          ? route
          : `/${route}`;

        this.$router.push(routePath).catch(() => {});
        return;
      }

      if (route.name) {
        this.$router
          .push({
            name: route.name,
            query: route.query || {},
            params: route.params || {},
          })
          .catch(() => {});
        return;
      }

      if (route.path) {
        this.$router
          .push({
            path: route.path,
            query: route.query || {},
          })
          .catch(() => {});
      }
    },

     async getUser() {
  const localToken = localStorage.getItem("token");

  if (!localToken) {
    this.render = true;

    // Clear only authentication-related data
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");

    this.$store.commit("UPDATE_USER", null);

    if (!["/", "/login"].includes(this.$route.path)) {
      this.$router.replace("/login");
    }

    return;
  }

  this.render = false;

  try {
    const res = await axios.get(
      process.env.VUE_APP_BASE_URL + "/auth/me",
      {
        headers: {
          Authorization: `Bearer ${localToken}`,
        },
      }
    );

    const user = res.data.data;

    if (!user || !user.id) {
      throw new Error("Invalid user response");
    }

    // Update Vuex using your existing mutation
    this.$store.commit("UPDATE_USER", user);

    localStorage.setItem("user_id", String(user.id));

    const publicPages = ["/", "/login"];

    if (publicPages.includes(this.$route.path)) {
      await this.$router.replace("/dashboard");
    }

  } catch (error) {
    console.error("Unable to restore user session:", error);

    localStorage.removeItem("token");
    localStorage.removeItem("user_id");

    this.$store.commit("UPDATE_USER", null);

    if (!["/", "/login"].includes(this.$route.path)) {
      await this.$router.replace("/login");
    }
  } finally {
    this.render = true;
  }
},
    playPingSound() {
      if (!this.audioUnlocked || !this.audio) return;

      try {
        this.audio.currentTime = 0;
        this.audio.play().catch(() => {});
      } catch (error) {
        console.warn("Audio play failed:", error);
      }
    },
  },
};
</script>

<style>
.socket-notification-stack-enter-active,
.socket-notification-stack-leave-active,
.socket-notification-stack-move {
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
}

.socket-notification-stack-enter-from,
.socket-notification-stack-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.socket-notification-stack-leave-active {
  position: absolute;
  width: 100%;
}

.socket-notification-fade-enter-active,
.socket-notification-fade-leave-active {
  transition:
    opacity 0.18s ease,
    transform 0.18s ease;
}

.socket-notification-fade-enter-from,
.socket-notification-fade-leave-to {
  opacity: 0;
  transform: translateY(4px);
}

.socket-notification-progress {
  width: 100%;
  transform-origin: left center;
  animation-name: socketNotificationProgress;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}

@keyframes socketNotificationProgress {
  from {
    transform: scaleX(1);
  }

  to {
    transform: scaleX(0);
  }
}
</style>
